export interface IRegionState {}

let regionState: IRegionState = {};

export default regionState;
